<!-- Remove Modal -->
<ng-container *ngIf="ngDialogData.modalName == Remove_Modal">
    <dls-dialog-header>
        <span>{{ngDialogData.title}}</span>
        <span class="pt-icon close-icon type-close-btn icon__cross" (click)="closeThisDialog({action:'cancel'})"></span>
    </dls-dialog-header>

    <dls-dialog-content>
        <span translate="CONFIRM_REMOVE_WORKLIST"
            translate-default="Are you sure you want to remove the current test from your worklist?"> </span>
    </dls-dialog-content>

    <dls-dialog-footer class="modal-buttons-section">
        <gen-button class="Auto_Popup_Cancel_Button"
            (click)="closeThisDialog({action:'cancel'})"
            [type]="'border'"
            [text]="'Cancel'"></gen-button>
        <gen-button class="Auto_Popup_Submit_Button"
            (click)="closeThisDialog({action:'ok'})"
            [type]="'primary'"
            [text]="'OK'"
            [btnClasses]="'Auto_Button_primary gen-button-element primary__button Auto_Button_Submit'"></gen-button>
    </dls-dialog-footer>
</ng-container>

<!-- Reassign Modal -->
<ng-container *ngIf="ngDialogData.modalName != Remove_Modal">

    <dls-dialog-header>
        <div>
            <span class="reassigntitle">{{titlePrefix}}</span>{{ngDialogData.title}}
        </div>
        <span *ngIf="!reassignFinished" class="pt-icon close-icon type-close-btn icon__cross crossButton"
              (click)="closeThisDialog({action:'cancel'})"></span>
        <span *ngIf="reassignFinished" class="pt-icon close-icon type-close-btn icon__cross crossButton"
              (click)="closeThisDialog({action:'close', payload:(reassignFinished ? selectedPractId : null)})"></span>
    </dls-dialog-header>

    <dls-dialog-content>

        <!-- All the Selections containt for three modals -->
        <div [ngSwitch]="ngDialogData.modalName">
        <div *ngIf="exceededTestsAmount" class="exceededTestsContainer">
            <div class="warning">Warning: </div>
            <div>The number of items you have selected has exceeded the limit. The first {{maxItemsCount}} will be executed</div>
        </div>

            <!-- Reassign_Test start -->
            <ng-container *ngSwitchCase = "Reassign_Test">
                <div *ngIf="(selectedOpt=='value3' || (selectedOpt=='value1' && !assignToMeStatusForTestIsDisabled())) && showWarningMessageForReassignOperation">
                  <p><dls-icon class="icon-dls-warning-icon"></dls-icon> {{pracOpinionName}} selections will be removed. Would you like to reassign?</p>
                </div>
                <!-- Assign to me -->
                <div class="field-radiobutton displayInline" (click)="setSelectedPractId(practitionerId, 'value1')"
                    [ngClass]="{'divDisabled' : assignToMeStatusForTestIsDisabled()}">
                    <p-radioButton name="selectedOpt1" value="value1" [(ngModel)]="selectedOpt" inputId="selectedOpt1"
                        [disabled]="assignToMeStatusForTestIsDisabled()" class="radioBtn"></p-radioButton>
                    <label for="selectedOpt1">Assign to me</label>
                </div>

                <!-- Assign to Pool -->
                <div class="field-radiobutton displayInline" (click)="setSelectedPractId(VALUE_NONE, 'value2')"
                    [ngClass]="{'divDisabled' : assignToPoolStatusIsDisabled()}">
                    <p-radioButton name="selectedOpt2" value="value2" [(ngModel)]="selectedOpt" inputId="selectedOpt2"
                        [disabled]="assignToPoolStatusIsDisabled()" class="radioBtn"></p-radioButton>
                    <label for="selectedOpt2">Assign to pool</label>
                </div>

                <!-- Assign Item to specific one -->
                <div class="field-radiobutton displayInline">

                    <p-radioButton name="selectedOpt3" value="value3" [(ngModel)]="selectedOpt"
                        inputId="selectedOpt3" class="radioBtn" (click)="setSelectedPractId(tempPractId, 'value3')"></p-radioButton>
                    <label for="selectedOpt3" class="dropdownPadding" (click)="setSelectedPractId(tempPractId, 'value3')">Assign to : </label>

                    <gen-dynamic-form
                        class="reassign-ie"
                        [formConfig]="practitionerSelectorForm"
                        [disabled]="reassigninginProgress || reassignFinished || reassignFailed"
                        [formData]="selectedPractObject"
                        [additionalSearchValues]="additionalSearchValues"
                        (formChange)="setReassignPractitioner($event.form.practitioner)">
                    </gen-dynamic-form>
                </div>
            </ng-container>
            <!-- Reassign_Test end -->

            <!-- Reassign_Test_By_Role start -->
            <ng-container *ngSwitchCase = "Reassign_Test_By_Role">
                <!-- Assign to me -->
                <div class="field-radiobutton displayInline"
                    (click)="setSelectedPractId(VALUE_NONE, 'value1'); onAssigneeTypeClick('me', selectedPractId)"
                        [ngClass]="{'divDisabled' : optionSelectionDisabled()}">
                    <p-radioButton name="selectedOpt1" value="value1" [(ngModel)]="selectedOpt" inputId="selectedOpt1"
                        [disabled]="optionSelectionDisabled()" class="radioBtn"></p-radioButton>
                    <label for="selectedOpt1">Assign test to me</label>
                </div>

                <!-- Assign to specific role -->
                <ng-container *ngFor="let role of ngDialogData.practitionerRoles">
                    <div class="field-radiobutton displayInline"
                        (click)="setSelectedPractId(tempPractId, 'value3'); onAssigneeTypeClick(role, roleObj[role + 'tempId'])">

                        <p-radioButton name="selectedOpt3" value="value3" [(ngModel)]="selectedOpt"
                            inputId="selectedOpt3" class="radioBtn"></p-radioButton>
                        <label for="selectedOpt3">Assign test to {{role}} : </label>

                        <select [disabled]="reassigninginProgress || reassignFinished || reassignFailed"
                                [(ngModel)]="roleObj[role + 'tempId']"
                                (change)="selectedPractId = roleObj[role + 'tempId']"
                                class="fs6_5 Spacebox__tiny assignee-select"
                                *ngIf="practitionersByRole[role].length > 0">
                                <option *ngFor="let item of practitionersByRole[role]" [(ngValue)]="item.id">{{item.fullName}}</option>
                        </select>
                    </div>
                </ng-container>
            </ng-container>
            <!-- Reassign_Test_By_Role end -->

            <!-- Reassign_Curation start -->
            <ng-container *ngSwitchCase = "Reassign_Curation">
                <!-- Assign to me -->
                <div class="field-radiobutton displayInline" (click)="setSelectedPractId(practitionerId, 'value1')"
                    [ngClass]="{'divDisabled' : assignToMeStatusForNonTestIsDisabled()}">
                    <p-radioButton name="selectedOpt1" value="value1" [(ngModel)]="selectedOpt" inputId="selectedOpt1"
                        [disabled]="assignToMeStatusForNonTestIsDisabled()" class="radioBtn"></p-radioButton>
                    <label for="selectedOpt1">Assign to me</label>
                </div>

                <!-- Assign to specific one -->
                <div class="field-radiobutton displayInline">

                    <p-radioButton name="selectedOpt3" value="value3" [(ngModel)]="selectedOpt"
                        inputId="selectedOpt3" class="radioBtn"
                        (click)="setSelectedPractId(tempPractId, 'value3')"></p-radioButton>
                    <label for="selectedOpt3" class="dropdownPadding"
                    (click)="setSelectedPractId(tempPractId, 'value3')">Assign item to : </label>

                    <gen-dynamic-form
                        class="reassign-ie"
                        [formConfig]="practitionerSelectorFormCurationItem"
                        [disabled]="reassigninginProgress || reassignFinished || reassignFailed"
                        [formData]="selectedPractObject"
                        [additionalSearchValues]="additionalSearchValues"
                        (formChange)="setReassignPractitioner($event.form.practitioner)">
                    </gen-dynamic-form>
                </div>
            </ng-container>
            <!-- Reassign_Curation end -->

        </div>

        <!-- text area -->
        <div class="Flexbox Flexbox__direction-rows fs6_5 ff_CentraleSansLight">
            <span class="text-gray">Add notes (optional)</span>
            <textarea class="textArea" [(ngModel)]="reassignNote"
                [disabled]="reassigninginProgress || reassignFinished || reassignFailed || !selectedPractId"
                placeholder= "{{'TYPE_HERE' | translate }}" cols="30" rows="4">
            </textarea>
        </div>

    </dls-dialog-content>

    <!-- footer buttons -->
    <dls-dialog-footer class="modal-buttons-section">
        <gen-button class="Auto_Popup_Submit_Button"
            *ngIf="(testIsArchieved || originalPractitioner !== selectedPractId) && !reassigninginProgress && !reassignFinished && !reassignFailed && selectedPractId"
            (click)="reassignTest(ngDialogData.analysis)"
            [type]="'primary'"
            [text]="'Reassign'"
            [btnClasses]="'Auto_Button_primary gen-button-element primary__button Auto_Button_Submit'"></gen-button>

        <gen-button class="Auto_Popup_Submit_Button"
            *ngIf="reassignFinished"
            [type]="'proceed'"
            [text]="'REASSIGNED'"
            [iconClass]="'icon__check fs8'"></gen-button>

        <gen-button class="Auto_Popup_Cancel_Button"
            *ngIf="!reassigninginProgress && !reassignFinished"
            (click)="closeThisDialog({action:'cancel'})"
            [type]="'border'"
            [text]="'Cancel'"></gen-button>

        <gen-button class="Auto_Popup_Cancel_Button"
            *ngIf="!reassigninginProgress && reassignFinished"
            (click)="closeThisDialog({action:'close', payload:(reassignFinished ? selectedPractId : null)})"
            [type]="'border'"
            [text]="'Close'"></gen-button>

        <p-progressSpinner *ngIf="reassigninginProgress"
            [style]="{width: '45px', height: '45px'}" styleClass="custom-spinner" strokeWidth="4" fill="white" animationDuration=".75s">
        </p-progressSpinner>

    </dls-dialog-footer>

</ng-container>
